export const ACTIONPLAN_ROUTE_NAMES = {
  TEACHER_INDEX: "teacherActionplansIndex",
  TEACHER_OVERVIEW: "teacherActionplansOverview",
  TEACHER_OVERVIEW_OPEN: "teacherActionplansOverviewOpen",
  TEACHER_OVERVIEW_COMPLETED: "teacherActionplansOverviewCompleted",
  TEACHER_REVIEW: "teacherActionplansReview",
  TEACHER_REVIEW_PENDING: "teacherActionplansReviewPending",
  TEACHER_REVIEW_COMPLETED: "teacherActionplansReviewCompleted",
  TEACHER_BATCH: "teacherActionplanBatch",
  STUDENT_INDEX: "studentActionplansIndex",
  STUDENT_OPEN: "studentActionplansOpen",
  STUDENT_COMPLETED: "studentActionplansCompleted",
  STUDENT_CREATE: "studentActionplanCreate",
  STUDENT_EDIT: "studentActionplanEdit",
} as const;

export type ActionplanRouteName =
  (typeof ACTIONPLAN_ROUTE_NAMES)[keyof typeof ACTIONPLAN_ROUTE_NAMES];
